var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFamilia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2C14 0.9 14.9 0 16 0C17.1 0 18 0.9 18 2C18 3.1 17.1 4 16 4C14.9 4 14 3.1 14 2ZM18 20V14H20.5L18 6.4C17.7 5.6 17 5 16.1 5H16C15.1 5 14.4 5.6 14.1 6.4L13.2 9C14.3 9.6 15 10.7 15 12.1V20H18ZM10.5 9.5C11.3 9.5 12 8.8 12 8C12 7.2 11.3 6.5 10.5 6.5C9.7 6.5 9 7.2 9 8C9 8.8 9.7 9.5 10.5 9.5ZM3.5 4C4.6 4 5.5 3.1 5.5 2C5.5 0.9 4.6 0 3.5 0C2.4 0 1.5 0.9 1.5 2C1.5 3.1 2.4 4 3.5 4ZM5.5 20V13H7V7C7 5.9 6.1 5 5 5H2C0.9 5 0 5.9 0 7V13H1.5V20H5.5ZM12 20V16H13V12C13 11.2 12.3 10.5 11.5 10.5H9.5C8.7 10.5 8 11.2 8 12V16H9V20H12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilia);
export default __webpack_public_path__ + "static/media/familia.78424dc419a174201df16e811d4cdb84.svg";
export { ForwardRef as ReactComponent };